




























































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import LoadingIndicator from '@/components/LoadingIndicator'
import SubmitBar from '@modules/ui/Offer/actions/SubmitBar'
import Back from '@modules/ui/buttons/Back'

import OfferHeader from '@modules/ui/Offer/OfferHeader'
import OfferDetails from '@modules/ui/Offer/steps/OfferDetails'
import BrandProvides from '@modules/ui/Offer/steps/BrandProvides'
import UniversityProvides from '@modules/ui/Offer/steps/UniversityProvides'
import Activations from '@modules/ui/Offer/steps/Activations'
import EmptyActivation from '@modules/ui/Offer/steps/EmptyActivation'

import OfferAlertBar from './OfferAlertBar'
import RequestButton from '@/components/RequestButton'

import Advance from '@modules/ui/Event/sections/SponsorAdvance/Advance'
import DayOfEvent from '@modules/ui/Event/sections/SponsorAdvance/DayOfEvent'

isDev = process.env.NODE_ENV is 'development'

settings =
  name: 'OfferShow'
  components: { Advance, DayOfEvent, LoadingIndicator, OfferAlertBar, Modal, SubmitBar, Back, OfferHeader, OfferDetails, BrandProvides, UniversityProvides, Activations, EmptyActivation, RequestButton }

  resources:
    offer:
      resourceName: "offer"
      slug: "offers/:offerId"
    audience_listing:
      resourceName: 'audience_listing'
      slug: 'audience_listings/:audienceListingId'
      fetch: false
    vendor_listing:
      resourceName: 'vendor_listing'
      slug: 'vendor_listings/:vendorListingId'
      fetch: false

  vue:
    props: ['offerId', 'options']
    computed:
      devMode: -> isDev

      audienceListingId: -> @ctxAudienceListing(@offer).id
      vendorListingId: -> @ctxVendorListing(@offer).id
      listing: -> @audience_listing || @vendor_listing

      enableActions: -> @options?.enableActions
      activations: -> (act for name, act of @offer?.activation_snapshots)
      activation: -> @activations?[0]
      isProductSampling: -> @offer.activation_snapshot_space_names[0] == 'Product Sampling'

      additionalOrganizerTOS: -> @listing?.special_terms

      offerProgress: ->
        acceptedCount = 0
        offerAcceptance = true
        acceptedCount++ if @offer.accepted
        for key, agreement of @offer.offer_acceptance_agreement
          offerAcceptance = offerAcceptance and agreement.accepted
          acceptedCount++ if agreement.accepted
        return { count: acceptedCount, accepted: offerAcceptance, percentComplete: Math.round(acceptedCount * 100 / 4) }
      offerStatusBorderClass: -> 
        switch @offer.state
          when 'pending', 'submitted' then 'border-draft'
          when 'accepted' then 'border-success'
          when 'denied' then 'border-red'
          else 'border-divider'
      offerStatusTagClass: -> 
        switch @offer.state
          when 'pending', 'submitted' then 'bg-draft'
          when 'accepted' then 'bg-success'
          when 'denied' then 'bg-red'
          else 'bg-recess'
      alertBg: -> 
        return 'bg-success' if @offer.accepted
        return 'bg-red' if @offer.denied || @offer.canceled || @offer.ignored
        return 'bg-draft' if @offer.in_revision
        switch @offerProgress.percentComplete
          when 0 then 'bg-recess'
          when 25, 50 then 'bg-draft'
          when 75 then 'bg-recess'
      alertStatus: ->
        return 'This offer has been accepted.' if @offer.accepted
        return 'This offer has been denied.' if @offer.denied
        return 'This offer has been canelled.' if @offer.canceled
        return 'This offer was ignored.' if @offer.ignored
        return 'This offer is currently being revised.' if @offer.in_revision
        switch @offerProgress.percentComplete
          when 0 then "Congratulations! You've received an offer. Please agree to the terms and accept the offer, if it is a good fit."
          when 25, 50 then 'Please agree to all of the terms in order to accept the offer.'
          when 75 then 'Thanks for agreeing to the terms. You can now accept the offer.'
    data: ->
      dataCollectionKeys: ["name", "email", "phone","grad_year", "dob", "mailing_address"]
      dataCollectionLabels: {name: "Name", email: 'Email', phone: 'Phone', grad_year: 'Graduation Year', dob: 'Date of Birth', mailing_address: 'Mailing Address'}
      openPanel: null
      showMoreOfferActions: false
      actionModal:
        show: false
        action: null
        button:
          label: ''
          handler: null

    mounted: ->
      @hiNavigateToTab('overview') unless @$route.params.tab?

    methods:
      hiNavigateToTab: (tab) ->
        @$router.push({ name: @$route.name, params: { tab } })

      onLoadItemCompleted: (resourceKey) ->
        if resourceKey is 'offer'
          if @audienceListingId
            @fetch 'audience_listing'
          else if @vendorListingId
            @fetch 'vendor_listing'

      promptToSubmit: ->
        @actionModal = 
          show: true
          action: 'submit'
          button: { label: 'Submit Offer', handler: @submitOffer }
      submitOffer: ->
        @triggerResource 'offer', 'submit' if @offer.submittable # +++ alert message if not submittable
        @actionModal.show = false

      promptToRevise: ->
        @actionModal = 
          show: true
          action: 'revise'
          button: { label: 'Revise Offer', handler: @reviseOffer }
      reviseOffer: ->
        @triggerResource 'offer', 'revise' if @offer.denied
        @actionModal.show = false

      promptToRevoke: ->
        @actionModal = 
          show: true
          action: 'revoke'
          button: { label: 'Revoke Offer', handler: @revokeOffer }
      revokeOffer: ->
        @triggerResource 'offer', 'revoke'
        @actionModal.show = false
      
      promptToResubmit: ->
        @actionModal = 
          show: true
          action: 'resubmit'
          button: { label: 'Resubmit Offer', handler: @resubmitOffer }
      resubmitOffer: ->
        @triggerResource 'offer', 'resubmit' if @offer.in_revision
        @actionModal.show = false
      
      promptToCancel: ->
        @actionModal = 
          show: true
          action: 'cancel'
          button: { label: 'Cancel Offer', handler: @cancelOffer }
      cancelOffer: ->
        @triggerResource 'offer', 'cancel'
        @actionModal.show = false
export default VueOptions.vue settings

